{
  "title": "Shield of Faith",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level abjuration",
  "level": 1,
  "castingTime": "1 bonus action",
  "range": "60 feet",
  "components": "V, S, M (a small parchment with a bit of holy text written on it)",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "A shimmering field appears and surrounds a creature of your choice within range, granting it a +2 bonus to AC for the duration."
  ],
  "spellLists": ["cleric", "paladin"]
}
